module.exports = __webpack_public_path__ + "img/7m.bf0494e9.png";